module.exports = __webpack_public_path__ + "static/media/joker.abeb0c4b.jpg";